<template>
    <div class="animated fadeIn">        
        <b-card>
            <div slot="header">
                Inventory RETURN Form
                <div class="card-header-actions">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                  <button class="btn btn-danger mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
                </div>
            </div>
            <b-form>
              <b-row>
                <b-col lg="8">
                    <b-row>
                        <b-col lg="7">
                            <b-input-group >
                                <b-input-group-prepend><label style="width:160px;">Issued Store/Warehouse</label></b-input-group-prepend>
                                <b-form-input v-model="model.namaStore" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="5">
                        <b-input-group>
                            <b-input-group-prepend><label style="width:75px;">Issued for</label></b-input-group-prepend>
                                <b-form-input v-model="model.typeIssued" readonly></b-form-input>
                            </b-input-group>
                        </b-col>
                    </b-row>    
                    
                    <b-row>
                        <b-col lg="7">
                        <b-input-group>
                            <b-input-group-prepend><label>Issued Number</label></b-input-group-prepend>
                            <b-form-input v-model="model.issuedno" readonly></b-form-input>
                        </b-input-group>
                        </b-col>
                        <b-col lg="5">  
                            <b-input-group >
                                <b-input-group-prepend><label style="width:160px;">Issued Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.isseudDate" readonly></b-form-input>
                            </b-input-group>                          
                        </b-col>
                    </b-row>    
                    <b-row>
                        <b-col lg="7">
                            <b-input-group >
                                <b-input-group-prepend><label>Retur No.</label></b-input-group-prepend>
                                <b-form-input readonly v-model="model.returno" ></b-form-input>
                            </b-input-group>
                        </b-col>
                        <b-col lg="5">
                           <b-input-group>
                                <b-input-group-prepend><label style="width:160px;">Retur Date</label></b-input-group-prepend>
                                <b-form-input v-model="model.tanggal" type="date" @change="tanggalBerubah" :state="!$v.model.tanggal.$error"></b-form-input>                                        
                            </b-input-group>
                        </b-col>
                    </b-row>    
                    <b-input-group >
                        <b-input-group-prepend><label>Retur Note</label></b-input-group-prepend>
                        <b-form-input v-model="model.uraian" :state="!$v.model.uraian.$error" placeholder="Note/Remark"></b-form-input>
                    </b-input-group>
                </b-col>
               
              </b-row>
              <b-card no-body class="mb-1">
                <b-table
                    class="mb-0"
                    ref="tblIssuedLines"
                    outlined
                    striped hover small
                    style="font-size:smaller;"
                    :items="issuedLines.items"
                    :fields="issuedLines.fields"
                    :current-page="issuedLines.page"
                    :per-page="issuedLines.limit"
                    show-empty
                    >
                        <template v-slot:cell(index)="data">
                        {{data.index + 1}}
                        </template>
                        <template v-slot:cell(partnumber)="data">
                            {{data.item.partnumber}} | {{data.item.itemname}}
                        </template>
                        <template v-slot:cell(quantityB4)="data">
                            {{data.item.quantityB4}} {{data.item.unitsize}}
                        </template>
                        <template v-slot:cell(quantity)="data">
                             <b-input-group>
                                <b-form-input v-model="data.item.quantity" type="number" :state="!$v.issuedLinesObj.quantity.$error" :min="1" @change="changeQtyIssued(data)" v-b-tooltip.hover title="isi dg QTY Minus"></b-form-input>
                            </b-input-group>
                        </template>
                        <template v-slot:cell(issueValue)="data">
                            <span style="float: left;">{{data.item.matauang}}</span>
                            <span>{{data.item.issueValue|numFormat}}</span>
                        </template>  
                        <template v-slot:cell(empty)="scope">
                            <h4>{{ scope.emptyText }}</h4>
                        </template>
                        <template v-slot:cell(emptyfiltered)="scope">
                            <h4>{{ scope.emptyFilteredText }}</h4>
                        </template>                   
                </b-table>
                <b-form-row>
                    <b-col cols="6">
                        <b-row>
                        <div class="ml-2">
                            Showing
                            {{(issuedLines.page - 1) * issuedLines.limit + 1}}
                            to
                            {{issuedLines.page * issuedLines.limit}}
                            <strong>
                            of
                            {{issuedLines.total}}
                            entries </strong>
                        </div>    
                        </b-row>                    
                    </b-col>
                    <b-col cols="6">
                    <b-pagination
                        align="right"
                        :total-rows="issuedLines.total"
                        :per-page="issuedLines.limit"
                        v-model="issuedLines.page"
                    ></b-pagination>
                    </b-col>
                </b-form-row>
              </b-card>    
            </b-form>
            <b-row class="justify-content-center mb-2">
                <button  v-if="saveEnabled" class="btn btn-primary mr-1" @click="save()"><i class="fa fa-save"></i> Save</button>
                <button class="btn btn-primary" @click="close()" > <i class="fa fa-close"></i> Close</button>
            </b-row>
        </b-card>
    </div>
</template>
<style lang="scss">
    .report-wraper {
         width:100%;
         overflow-x: auto;
         overflow-y: auto;
        min-height: 100px;
        border: 1px solid silver;
        table {
            font-size: smaller;
            th {
                border: 1px solid silver;
                padding: 0 15px;
                height: 30px;
                background: #e8e8e8;
            }              
            tbody tr:hover {
                background-color: rgba(91,192,222, 0.2) !important;
                cursor: default;
            }

            td {
                border: 1px solid silver;
                padding: 0 10px;
                height: 25px;
            }
            
            td.tebal {
                font-weight: bold;
            }
            
            td.subtotal {
                border-top: 2px solid #000 !important;
            }
        }
    }
    .input-group {
        padding-bottom:2px;
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 130px;
            }
        }
    }
    .form-group {
        margin-bottom:2px;
        .input-group {
            padding-bottom:0;
        }
    }
    .row-details-form {
        .input-group-prepend {
            label {
                padding-top: 5px;
                padding-right: 5px;
                width: 80px;
            }
        }
        label {
        text-align: right !important;
        }
        legend {
        text-align: right !important;;
        }
    }
</style>

<script>
import toastr from "mini-toastr";
import moment from 'moment';
import myNumber from "../../components/my-number";
import vDim from "../lookup/dim";
import inv from "../../apis/logistic_inv_out";
// import procure from "../../apis/procure";
import dimension from "../../apis/dimension";
import { validationMixin } from "vuelidate";
import { required, numeric } from "vuelidate/lib/validators";
toastr.init();

export default {   
  components: { myNumber, vDim},
  mixins: [validationMixin],
  validations: {
        model: {
            uraian: { required },
            tanggal: { required },
        },
        issuedLinesObj: {
            itemno: { required },
            // remark: { required:requiredUnless('qtyUndefined') },
            quantity: { numeric, required},
            nilai: { numeric, required }
        },
  }, 
  data() {
    return {
        saveEnabled:true,
        isEdit:false,
        horizontal:true,
        lkuItemShow:false,
        lkuMrShow:false,
        lkuSalesShow:false,
        updateDimHdr:false,
        updateDimDtl:true,
        tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
        uanguser: this.$store.state.user.matauang,
        currency:[{value:'IDR',text:'IDR'}],
        Warehouse : [],
        model:{uraian:'',tanggal:''},
        issuedLines: {
            items: [],
            selected:{},
            fields: [
                {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                {
                    key: "partnumber",
                    label: "Item Inventory",
                },
                {
                    key: "quantityB4",
                    label: "Qty. Issued",
                    thStyle: "width:150px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "quantity",
                    label: "Qty. Retur (isi MINUS)",
                    thStyle: "width:150px",
                    thClass: "text-center",
                    tdClass: "text-center"
                },
                {
                    key: "issueValue", // diisi dengan issueValue
                    label: "Estimate Price",
                    thStyle: "width:150px",
                    thClass: "text-right",
                    tdClass: "text-right"
                },
            ],
            page: 1,
            limit: 5,
            total: 0,
        },
        issuedLinesObj:{itemno:'', quantity:0, nilai:0},

    };
},
    computed: {
        dimension(){
        return this.$store.state.dimension;
        },
        invalidIssuedLines() {
        //   this.issuedLines.kenappn= (this.issuedLines.ppn != 0); 
        this.$v.issuedLinesObj.$touch();
        return this.$v.issuedLinesObj.$invalid;
        },
        invalidModel() {
        this.$v.model.$touch();
        return this.$v.model.$invalid;
        },
        unitprice(){
            return this.issuedLinesObj.invUnitCost;
        },
        qtyUndefined(){
            if(this.issuedLinesObj.qtyUndefined==1){
                return true;
            }else{
                return false;
            }
        },
        ifSales(){
            if(model.sales == 1){
                return true;
            }else{
                return false;
            }
        }
    },
    watch: {
        unitprice: function(newval) {
            setTimeout(() => {
                this.calcAmount();
            }, 100);
        },    
    },
    created: async function(){
        
        if (this.$route.params.invIssueKeyB4 || this.$route.params.invIssueKey) {
            try {
                if(this.$route.params.invIssueKey){
                    this.isEdit = true;
                    this.issuedLines.fields= [
                        {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                        {
                            key: "partnumber",
                            label: "Item Inventory",
                        },
                        {
                            key: "quantity",
                            label: "Qty. Retur (isi MINUS)",
                            thStyle: "width:150px",
                            thClass: "text-center",
                            tdClass: "text-center"
                        },
                        {
                            key: "unitsize",
                            label: "UnitSize",
                            thStyle: "width:150px",
                            thClass: "text-center",
                            tdClass: "text-center"
                        },
                        {
                            key: "issueValue", // diisi dengan issueValue
                            label: "Estimate Price",
                            thStyle: "width:150px",
                            thClass: "text-right",
                            tdClass: "text-right"
                        }]
                } else {
                    this.issuedLines.fields= [
                        {key: 'index', label: 'No.' ,thStyle: "width:40px"},
                        {
                            key: "partnumber",
                            label: "Item Inventory",
                        },
                        {
                            key: "quantityB4",
                            label: "Qty. Issued",
                            thStyle: "width:150px",
                            thClass: "text-center",
                            tdClass: "text-center"
                        },
                        {
                            key: "quantity",
                            label: "Qty. Retur (isi MINUS)",
                            thStyle: "width:150px",
                            thClass: "text-center",
                            tdClass: "text-center"
                        },
                        {
                            key: "issueValue", // diisi dengan issueValue
                            label: "Estimate Price",
                            thStyle: "width:150px",
                            thClass: "text-right",
                            tdClass: "text-right"
                        },
                    ];

                }
                toastr.info('Loading Retur Detail, please wait')
                const obj = {
                    invIssueKey: this.$route.params.invIssueKeyB4 || this.$route.params.invIssueKey
                }
                const [a,b,data] = await Promise.all([inv.issuegroup(),inv.store(),inv.detail(obj)]) ;
                
                this.issuedGroups = a;
                this.Warehouse = b;
                const row = data[0][0];
                console.log('created header',row)
                console.log('created line',data[1])
                // this.saveEnabled=(row.send2wf === 0);
                row.isseudDate = this.isEdit?moment(row.tanggalB4).format('YYYY-MM-DD'):row.tanggal ? moment(row.tanggal).format('YYYY-MM-DD') : '';
                row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : '';
                row.mrsrno = row.requestno || '';
            
                for (var key in row) {
                    this.model[key] = row[key];
                }
                this.model.uraian = this.isEdit?row.uraian:''; // diisi dengan uraian retur
                this.model.tanggal = this.isEdit?moment(row.tanggal).format('YYYY-MM-DD'):'';
                this.model.issuedno = this.isEdit?row['nomorB4']:row['nomor'];
                this.model.returno = this.isEdit?row['nomor']:'';
                this.model.receivedby = row['receivby']
                this.model.typeIssued = row.sales == 1 ? 'Sales/Trading':'Internal Usage';
                const isEdit = this.isEdit;
                data[1].forEach(function(item,idx){
                    data[1][idx].quantityB4 = isEdit?item.qtyIssuedB4 : item.qtyIssued;
                    data[1][idx].quantity = isEdit ? item.qtyIssued : 0;
                    data[1][idx].issueValue = isEdit ? item.issueValue : 0;
                    data[1][idx].unitsize = item.invunitom
                    data[1][idx].unitprice = item.invUnitCost
                    data[1][idx].maxQuantity = item.qtyIssued // ini untuk membatasi jumlah retur
                });            
                
                this.issuedLines.items = data[1]
                // this.model.terms = data[2];
                this.calcTotalDtlIssued();
                this.tanggalBerubah();
                this.updateDimHdr = !this.updateDimHdr;
                this.$forceUpdate();                
                toastr.clear;
            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "ERROR MESSAGE");                              
            }
       
        }else{
            const [a,b] = await Promise.all([inv.issuegroup(),inv.store()]) ;
            this.issuedGroups = a;
            this.Warehouse = b;
        } 
    },
  methods: {
    // addIssuedLines : function () {
    //     const obj={_showDetails:true};
    //     this.issuedLines.selected = obj;
    //     for (var key in this.issuedLinesObj) {
    //         this.issuedLinesObj[key] = '';
    //     }
    //     this.issuedLinesObj.unitsize='EACH';
    //     this.issuedLinesObj.quantity = 1;
    //     this.issuedLinesObj.qtyUndefined = 0;
    //     this.updateDimHdr2Dtl(this.issuedLinesObj);
    //     this.issuedLines.items.push(obj);
    //     this.issuedLines.total=this.issuedLines.items.length;
    // },
    // editIssuedLines : function (obj,callback) {        
    //     this.issuedLines.selected = obj;
    //     for (var key in this.issuedLinesObj) {
    //         this.issuedLinesObj[key] = '';
    //     }
    //     for (var key in obj) {
    //         this.issuedLinesObj[key] = obj[key];
    //     }
        
    //     this.issuedLinesObj.qtyIssued = this.isEdit ? obj.qtyIssuedB4 : obj.qtyIssued;
    //     this.issuedLinesObj.quantity = this.isEdit ? obj.quantity :obj.quantity;
    //     this.issuedLinesObj.iteminfo = `${obj.itemno} | ${obj.itemname}`
    //     this.issuedLinesObj.typeseries = obj.itemcategory

    //     this.dimension.forEach((dim) => {
    //         if (obj[dim.value]) {
    //             this.issuedLinesObj[dim.value] = obj[dim.value];
    //             this.issuedLinesObj[`${dim.value}Txt`] = obj[`${dim.value}Txt`];
    //             this.issuedLinesObj[`${dim.value}Info`] = obj[dim.value] + ' | '+ obj[`${dim.value}Txt`];
    //         }
    //     });
    //     callback();
    // },
    // delIssuedLines: function (index) {
    //     if (index > -1) {
    //     this.issuedLines.items.splice(index, 1);
    //     }
    //     this.issuedLines.total=this.issuedLines.items.length;
    //     this.calcTotalDtlIssued();
    // },
    // saveIssuedLines: async function (callback) {
    //     this.calcAmount();
    //     if (this.invalidIssuedLines) {
    //         toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
    //    } else {
    //         let datadim=this.issuedLinesObj;
    //         datadim.TableName = 'mr_sr_line';
    //         try {
    //             const dimValResult = await dimension.validate(datadim);
    //             if (dimValResult.success) {
    //                 for (var key in this.issuedLinesObj) {
    //                     this.issuedLines.selected[key] = this.issuedLinesObj[key];
    //                 }
    //                 this.issuedLines.selected.issueValue = this.issuedLinesObj.quantity * this.issuedLinesObj.invUnitCost
    //                 this.dimension.forEach((dim) => {
    //                     if (datadim[dim.value]) {
    //                         this.issuedLines.selected[dim.value] = datadim[dim.value];
    //                         this.issuedLines.selected[`${dim.value}Txt`] = datadim[`${dim.value}Txt`];
    //                     }
    //                 });
    //                 this.updateDimDtl2Hdr(datadim);
    //                 this.calcTotalDtlIssued();
    //                 this.issuedLines.selected._showDetails=false;
    //                 if (callback) callback();
    //             } else {
    //                 var msg = dimValResult.message;
    //                 if (callback) callback(new Error(msg));
    //                 else {
    //                     toastr.error(msg, "ERROR MESSAGE",10000);
    //                 }
    //             }
    //         } catch (error) {
    //             console.log('error : ', error);
    //             if (error.message) {
    //                 toastr.error(error.message,'ERROR MESSAGE',10000);
    //             } else {
    //                 toastr.error(JSON.stringify(error),'ERROR MESSAGE',10000);
    //             }
    //         }
    //     }
    // },
    save: async function () {
        if (!this.saveEnabled) {
            toastr.error('View mode cannot be Saved');
            return;
        }
        if (this.invalidModel) {
            console.log('validation : ', this.$v.model);
            console.log('model obj : ',this.model);
            toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
                this.model.TableName = 'mr_sr_header';
                const dimValResult = await dimension.validate(this.model);
                if (dimValResult.success) {
                    // this.model.DimTableKey = diisi dari PR/SR;
                    if(!this.isEdit){
                        this.model.nomor = '';
                        this.model.invIssueKeyB4 = this.model.invIssueKey;
                    }
                    
                    const row = {};
                    for (var key in this.model) {
                        row[key] = this.model[key];
                    }
                    row.terms = this.model.terms;
                    row.issueddate = moment(row.issueddate).format('YYYY-MM-DD');
                    row.expectreceipt = row.expectreceipt ? moment(row.expectreceipt).format('YYYY-MM-DD') : undefined;
                    let lineno=1;
                    row.lines = this.issuedLines.items.reduce((newArr, item) => {
                        if (item.quantity) {
                            if(!this.isEdit){
                                const itemInvIssueKey = item.invIssueKey;
                                const itemInvIssueDtlKey= item.invIssueDtlKey
                                item.invIssueKey = '';
                                item.invIssueDtlKey = '';
                                item.invIssueDtlKeyB4 = itemInvIssueDtlKey;
                                item.lineno = lineno;
                            }
                            item.qtyIssued = (item.quantity>0) ? item.quantity * -1 : item.quantity;
                            newArr.push(item);
                            lineno += 1;
                        }
                        return newArr;
                    }, []);
                    if (row.lines.length>0) {
                        //  ini untuk membedakan issued untuk retur
                        if(!this.isEdit){
                            row.invIssueKey ='';
                            row.isReturn = 1;
                            row.issuedkey = '';
                            row.issuedno = '';
                        }
                        
                        // end
                        await inv.save(row);
                        toastr.success("Complete successfully", "Save Request");
                        this.close();
                    } else {
                        toastr.error('Please fill at least 1(one) Request Detail', 'ERROR MESSAGE');
                    }
                } else {
                    
                    var msg = dimValResult.message || 'Dimension validation error';
                    toastr.error(msg, "ERROR MESSAGE");
                }

            } catch (error) {
                console.log('error : ', error);
                toastr.error(JSON.stringify(error), "Save Request Error");                
            }

        }
    },
    changeQtyIssued:function (data){
        const {item,index} = data;
        this.issuedLines.items[index].issueValue = item.quantity * item.invUnitCost;
    },
    tanggalBerubah: function(){
        this.tahun=moment(this.model.tanggal).format('YYYY');
    },
    calcAmount : function () {
        this.issuedLinesObj.nilai = parseFloat(this.issuedLinesObj.quantity) * parseFloat(this.issuedLinesObj.invUnitCost);
    },
    calcTotalDtlIssued: function () {
        let ttlnetto = 0;
        this.issuedLines.items.forEach((trx)=> {
            if (trx.itemno) {
                ttlnetto += (trx.nilai || 0);
            }
        });
        this.model.ttlnetto = ttlnetto;
    },

    close(){
    //   console.log('this.$store.state.prevRoute.name : ',this.$store.state.prevRoute.name);
      if ((this.$store.state.prevRoute.name) && (this.$store.state.prevRoute.name !== 'logistic.issuedform')) {
        router.push({name:this.$store.state.prevRoute.name});
      } else {
        // router.push({name:'payable.apinv'});
          router.push("home");
      }
    }
  }
};
</script>
